module.exports = __webpack_public_path__ + "files/SPIADI2026 - Fiche établissement.b51c5a1003359cff2ef0bec54d2e4fa6.pdf";